import { FilterSelection } from "@app/core/classes/filterSelection";
import { logDispatcher } from "@app/core/decorators/state.decorators";

export namespace FilterActions {

  @logDispatcher
  export class Filters {
    static readonly type = '[Filters API] Filters';
    constructor(public filter: FilterSelection) { }
  }
}